module.exports = {
  ON_INIT: 'ON_INIT',
  SET_LOADING: 'SET_LOADING',
  LOCALE_LOADED: 'LOCALE_LOADED',
  LOAD_ASSETS: 'LOAD_ASSETS',
  SET_SOUND_AVAILABLE: 'SET_SOUND_AVAILABLE',
  LOAD_SOUNDS: 'LOAD_SOUNDS',
  SOUNDS_LOADED: 'SOUNDS_LOADED',
  SET_INFOCUS: 'SET_INFOCUS',
  SET_LOGGEDIN: 'SET_LOGGEDIN',
  READY: 'READY',
  UPDATE_PROGRESS: 'UPDATE_PROGRESS',
  HIDE_LOADER: 'HIDE_LOADER',
  ON_REFRESH: 'ON_REFRESH',
  PLAY_REQUEST: 'PLAY_REQUEST',
  PLAY: 'PLAY',
  ON_PLAY_RESPONSE: 'ON_PLAY_RESPONSE',
  SET_PLAYING: 'SET_PLAYING',
  SET_DELAYING_SPIN: 'SET_DELAYING_SPIN',
  SET_PLAYING_REQUEST: 'SET_PLAYING_REQUEST',
  PLAY_DONE: 'PLAY_DONE',
  PLAY_DONE_CHECK: 'PLAY_DONE_CHECK',
  READY_FOR_PLAY_DONE: 'READY_FOR_PLAY_DONE',
  UPDATE_STATS: 'UPDATE_STATS',
  ON_TOKEN: 'ON_TOKEN',
  LOGIN: 'LOGIN',
  FUN_MONEY_LOGIN: 'FUN_MONEY_LOGIN',
  ON_LOGIN: 'ON_LOGIN',
  SET_BET: 'SET_BET',
  SET_SIDE_BET: 'SET_SIDE_BET',
  UPDATE_BET: 'UPDATE_BET',
  UPDATE_SIDE_BET: 'UPDATE_SIDE_BET',
  SET_SIDE_GAMES: 'SET_SIDE_GAMES',
  REQUEST: 'REQUEST',
  REQUEST_TIMEOUT: 'REQUEST_TIMEOUT',
  SET_WAITING_FOR_CONNECTION: 'SET_WAITING_FOR_CONNECTION',
  SAVE_SETTINGS: 'SAVE_SETTINGS',
  SETTINGS_SAVED: 'SETTINGS_SAVED',
  RESTORE_SETTINGS: 'RESTORE_SETTINGS',
  SET_SETTING: 'SET_SETTING',
  TOGGLE_SETTING: 'TOGGLE_SETTING',
  ERROR: 'ERROR',
  ERROR_CLOSED: 'ERROR_CLOSED',
  SET_EXTERNAL_ERROR_HANDLING: 'SET_EXTERNAL_ERROR_HANDLING',
  JACKPOT_MESSAGE_CLOSED: 'JACKPOT_MESSAGE_CLOSED',
  UPDATE_JACKPOT: 'UPDATE_JACKPOT',
  SHOW_MESSAGE: 'SHOW_MESSAGE',
  RESET_REALITYCHECK: 'RESET_REALITYCHECK',
  GO_TO_LOBBY: 'GO_TO_LOBBY',
  UPDATE_WIN: 'UPDATE_WIN',
  SET_FORCE_UPDATE: 'SET_FORCE_UPDATE',
  TOGGLE_MUTE: 'TOGGLE_MUTE',
  SET_MUTE: 'SET_MUTE',
  SET_MUTE_SFX: 'SET_MUTE_SFX',
  SET_MUTE_MUSIC: 'SET_MUTE_MUSIC',
  TOGGLE_SFX: 'TOGGLE_SFX',
  TOGGLE_MUSIC: 'TOGGLE_MUSIC',
  TOGGLE_SETTINGS_OPEN: 'TOGGLE_SETTINGS_OPEN',
  SET_HASSPLASH: 'SET_HASSPLASH',
  ON_SPLASHSTART: 'ON_SPLASHSTART',
  SET_HIDE_SPLASH: 'SET_HIDE_SPLASH',
  SET_HASINTRO: 'SET_HASINTRO',
  SET_HIDE_INTRO: 'SET_HIDE_INTRO',
  SET_INTRO_LOADED: 'SET_INTRO_LOADED',
  SET_SETTINGSSCREEN: 'SET_SETTINGSSCREEN',
  SET_SKIPFEATURE: 'SET_SKIPFEATURE',
  BLOCKED_SKIPFEATURE: 'BLOCKED_SKIPFEATURE',
  ADD_ENABLE_QUICKSPIN: 'ADD_ENABLE_QUICKSPIN',
  SET_QUICKSPIN_PROMPT_SHOWN: 'SET_QUICKSPIN_PROMPT_SHOWN',
  DISABLE_RESTORESTATE: 'DISABLE_RESTORESTATE',
  SET_RESTORESTATE: 'SET_RESTORESTATE',
  ON_START_RESTORE: 'ON_START_RESTORE',
  SET_SAVEDSETTINGS: 'SET_SAVEDSETTINGS',
  SET_PAUSED: 'SET_PAUSED',
  TOGGLE_SPACE_TO_SPIN: 'TOGGLE_SPACE_TO_SPIN',
  SET_SPACE_TO_SPIN: 'SET_SPACE_TO_SPIN',
  ATTEMPT_TO_SPIN: 'ATTEMPT_TO_SPIN',
  UPDATE_FREEROUND_TOTAL: 'UPDATE_FREEROUND_TOTAL',
  MAKE_FREEROUND_CHOICE: 'MAKE_FREEROUND_CHOICE',
  DISPLAY_FREEROUND: 'DISPLAY_FREEROUND',
  DISPLAY_HISTORY: 'DISPLAY_HISTORY',
  SET_ORIENTATION_CHECKED: 'SET_ORIENTATION_CHECKED',
  SET_FREEROUNDS_LEFT: 'SET_FREEROUNDS_LEFT',
  UPDATE_FREEROUNDS_LEFT: 'UPDATE_FREEROUNDS_LEFT',
  REFRESH_FREEROUNDS: 'REFRESH_FREEROUNDS', 
  SET_STEP_DEBUG: 'SET_STEP_DEBUG',
  SET_QUICKSPIN: 'SET_QUICKSPIN',
  SET_ALLOW_SPIN_REQUESTS: 'SET_ALLOW_SPIN_REQUESTS',
  CLOSE_GAMEROUND: 'CLOSE_GAMEROUND',
  CALLED_GAMEFINISHED: 'CALLED_GAMEFINISHED',
  RERUN_LAST_ROUND: 'RERUN_LAST_ROUND',
  TOGGLE_HOTZONE: 'TOGGLE_HOTZONE',
  TOGGLE_FPSMETER: 'TOGGLE_FPSMETER',
  TOGGLE_RECORDING_CONTROLS: 'TOGGLE_RECORDING_CONTROLS',
  TOGGLE_CONFIGURABLE_VARIABLES: 'TOGGLE_CONFIGURABLE_VARIABLES',
  TOGGLE_POPUP_TRIGGERER: 'TOGGLE_POPUP_TRIGGERER',
  TRIGGER_DEBUG_POPUP: 'TRIGGER_DEBUG_POPUP',
  SET_CHEAT: 'SET_CHEAT',
  SET_CHEATS: 'SET_CHEATS',
  SET_DEMO: 'SET_DEMO',
  SET_DEMO_INDEX: 'SET_DEMO_INDEX',

  SET_GAMESPEED: 'SET_GAMESPEED',
  SET_MENU_OPACITY: 'SET_MENU_OPACITY',
  SET_FALLBACK_RESPONSE: 'SET_FALLBACK_RESPONSE',
  CURRENCY_CHANGED: 'CURRENCY_CHANGED',
  SET_NOFULLSCREEN: 'SET_NOFULLSCREEN',
  SETTINGSCREENS: {
    INFO: 'INFO',
    SETTINGS: 'SETTINGS',
    RULES: 'RULES',
    AUTOPLAY: 'AUTOPLAY',
    BET: 'BET'
  },
  MESSAGE_TYPES: {
    ERROR: 'ERROR',
    REALITYCHECK: 'REALITYCHECK',
    MESSAGE_LOGIN: 'MESSAGE_LOGIN',
    SOUND_PROMPT: 'SOUND_PROMPT',
    HOME_PROMPT: 'HOME_PROMPT',
    FREEROUNDS: 'FREEROUNDS',
    JACKPOT: 'JACKPOT',
    QUICKSPIN_PROMPT: 'QUICKSPIN_PROMPT',
    GAME_RESTORE: 'GAME_RESTORE'
  },
  KEY_DOWN: 'KEY_DOWN',
  KEY_UP: 'KEY_UP',
  GAME_ACTIONS: {
    SPIN: 'spin',
    MAKE_PICK: 'makePick'
  },
  assetTypes: {
    asset: 'asset',
    font: 'font',
    sound: 'sound'
  },
  TOURNAMENTPOINTS: 'tournamentPoints',
  SET_FREEROUNDS_BET: 'SET_FREEROUNDS_BET',
  FORCE_NEW_BALANCE: 'FORCE_NEW_BALANCE',
  REQUEST_BALANCE_UPDATE: 'REQUEST_BALANCE_UPDATE',

  // POSTMESSAGE
  SET_EXTERNAL_PAUSE: 'SET_EXTERNAL_PAUSE',
  SET_EXTERNAL_PAUSE_REQUEST: 'SET_EXTERNAL_PAUSE_REQUEST',
  GAME_IS_READY: 'GAME_IS_READY',
  GAME_WAS_PAUSED: 'GAME_WAS_PAUSED',

  GameEvents: {
    ROUND_STARTED: 'CALL_GameEvent_ROUND_STARTED',
    ROUND_ENDED: 'CALL_GameEvent_ROUND_ENDED',
    WIN_PRESENTATION_STARTED: 'CALL_GameEvent_WIN_PRESENTATION_STARTED',
    WIN_PRESENTATION_ENDED: 'CALL_GameEvent_WIN_PRESENTATION_ENDED',
    FREE_SPINS_STARTED: 'CALL_GameEvent_FREE_SPINS_STARTED',
    FREE_SPINS_ENDED: 'CALL_GameEvent_FREE_SPINS_ENDED',
    BONUS_STARTED: 'CALL_GameEvent_BONUS_STARTED',
    BONUS_ENDED: 'CALL_GameEvent_BONUS_ENDED',
    JACKPOT_EVENT_STARTED: 'JACKPOT_EVENT_STARTED',
    JACKPOT_EVENT_ENDED: 'JACKPOT_EVENT_ENDED'
  },

  popupTriggerer: {
    NORMAL_ERROR: 'NORMAL_ERROR',
    CUSTOM_ERROR: 'CUSTOM_ERROR',
    SOUND_PROMPT: 'SOUND_PROMPT',
    GAME_RESTORE: 'GAME_RESTORE',
    HOME_PROMPT: 'HOME_PROMPT',
    REALITY_CHECK: 'REALITY_CHECK',
    QUICK_SPIN: 'QUICK_SPIN',
    MESSAGE_WITH_LOGIN: 'MESSAGE_WITH_LOGIN',
    JACKPOT_WON: 'JACKPOT_WON',
    FREE_ROUNDS: 'FREE_ROUNDS',
    FREE_ROUNDS_END: 'FREE_ROUNDS_END',
    FREE_ROUNDS_V2: 'FREE_ROUNDS_V2',
  }
}
